'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PasswordShowingIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PasswordShowingIcon">
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.5 12.5C8.5 12.9596 8.59053 13.4148 8.76642 13.8394C8.94231 14.264 9.20012 14.6499 9.52513 14.9749C9.85013 15.2999 10.236 15.5577 10.6606 15.7336C11.0852 15.9095 11.5404 16 12 16C12.4596 16 12.9148 15.9095 13.3394 15.7336C13.764 15.5577 14.1499 15.2999 14.4749 14.9749C14.7999 14.6499 15.0577 14.264 15.2336 13.8394C15.4095 13.4148 15.5 12.9596 15.5 12.5C15.5 12.0404 15.4095 11.5852 15.2336 11.1606C15.0577 10.736 14.7999 10.3501 14.4749 10.0251C14.1499 9.70012 13.764 9.44231 13.3394 9.26642C12.9148 9.09053 12.4596 9 12 9C11.5404 9 11.0852 9.09053 10.6606 9.26642C10.236 9.44231 9.85013 9.70012 9.52513 10.0251C9.20012 10.3501 8.94231 10.736 8.76642 11.1606C8.59053 11.5852 8.5 12.0404 8.5 12.5Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.38 12.17C22.21 10.85 17.56 6 12 6C6.43996 6 1.78996 10.85 0.61996 12.17C0.543581 12.263 0.501831 12.3796 0.501831 12.5C0.501831 12.6204 0.543581 12.737 0.61996 12.83C1.78996 14.15 6.43996 19 12 19C17.56 19 22.21 14.15 23.38 12.83C23.4563 12.737 23.4981 12.6204 23.4981 12.5C23.4981 12.3796 23.4563 12.263 23.38 12.17Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

PasswordShowingIcon.propTypes = {
  sx: PropTypes.object
}
